import { decode } from './decode'
import { encode } from './encode'

export const saveToLocalStorage = (key: string, value: string) => {
  localStorage.setItem(encode(key), encode(value))
}

export const getDataFromLocalStorage = (key: string): string | null => {
  const encodedValue = localStorage.getItem(encode(key))
  if (encodedValue !== null) {
    return decode(encodedValue)
  } else {
    return null
  }
}

export const removeDataFromLocalStorage = (key: string) => {
  localStorage.removeItem(encode(key))
}

/** Clears localStorage but preserves the given (unencoded) keys. */
export const clearLocalStorageExcept = (keepKeys: string[]) => {
  const keep = keepKeys
    .map((key) => [encode(key), localStorage.getItem(encode(key))] as const)
    .filter(([, value]) => value !== null)
  localStorage.clear()
  keep.forEach(([encodedKey, value]) => localStorage.setItem(encodedKey, value as string))
}
